import apiList from './apiList';

const apiUrlMap = {
  [apiList.SUPER_OYO_METRICS_URL]: '/hms_ms/api/v1/super-oyo-metrics-data',
  [apiList.CURRENT_PERFORMANCE_URL]: '/hms_ms/api/v1/home_page_current_performance',
  [apiList.GROWTH_HUB_HOST]: '/hms_ms/api/v1/growth_hub',
  [apiList.FETCH_NUMBER_UPDATE_DATA_URL]: '/hms_ms/api/v1/generic/campaign_page_widgets_v2',
  [apiList.RECONFIRMATION_PAGE_DATA]: '/hms_ms/api/v1/generic/campaign_page_widgets',
  [apiList.HMS_FEATURE_METADATA_URL]: '/hms_ms/api/v1/feature-metadata',
  [apiList.OWNERAPP_SCREEN_METADATA]: '/owner_ms/api/v1/app/screen-metadata',
  [apiList.FETCH_TRANSLATION_FEATURE_DATA_URL]: '/hms_ms/api/v1/feature-metadata',
  [apiList.REMOVE_RESTRICTION_URL]: '/hms_ms/api/v1/generic',
  [apiList.SUBMIT_PERFORMANCE_URL]: '/hms_ms/api/v1/generic',
  [apiList.RESEND_CHECKIN_VALIDATION_PIN]: '/hms_ms/api/v1/generic',
  [apiList.VALIDATE_CHECKIN_USING_PIN]: '/hms_ms/api/v1/generic',
  [apiList.GENERATE_OTP]: '/hms_ms/api/v1/generic/generate-otp',
  [apiList.VERIFY_OTP]: '/hms_ms/api/v1/generic/verify-otp'
} as const;

export default apiUrlMap;
